const a = (r) => {
  const s = location.origin.toString().replace(/\/$/, ""), t = r.toString(), n = t.startsWith(s), o = t.startsWith("/"), i = t.startsWith("http");
  return !n && !o && i;
};
export {
  a as isExternalUrl
};
